// ارقام فارسی برای نمایش (CLAUDE.md §6، IA §4.7: «نمایش ارقام فارسی، ورود هر دو نوع»).
// معادل PersianNormalizer.ToPersianDigits/ToLatinDigits/KeepDigitsOnly سرور (Phoenix.Localization).

const PERSIAN_ZERO = 0x06f0;
const ARABIC_INDIC_ZERO = 0x0660;
const LATIN_ZERO = 0x30;

/** جداکننده هزار فارسی (U+066C) — همان MoneyFormatter.PersianThousandsSeparator. */
export const PERSIAN_THOUSANDS_SEPARATOR = String.fromCharCode(0x066c);

function mapDigit(code: number): number {
  if (code >= PERSIAN_ZERO && code <= PERSIAN_ZERO + 9) {
    return LATIN_ZERO + (code - PERSIAN_ZERO);
  }
  if (code >= ARABIC_INDIC_ZERO && code <= ARABIC_INDIC_ZERO + 9) {
    return LATIN_ZERO + (code - ARABIC_INDIC_ZERO);
  }
  return code;
}

/** تبدیل ارقام لاتین به فارسی برای نمایش؛ ورودی عددی به رشته تبدیل می‌شود (بدون جداکننده). */
export function faDigits(value: string | number | bigint | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  let result = '';
  for (const ch of String(value)) {
    const code = ch.charCodeAt(0);
    result +=
      code >= LATIN_ZERO && code <= LATIN_ZERO + 9
        ? String.fromCharCode(PERSIAN_ZERO + (code - LATIN_ZERO))
        : ch;
  }
  return result;
}

/** تبدیل ارقام فارسی و عربی به لاتین. */
export function latinDigits(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  let result = '';
  for (const ch of value) {
    result += String.fromCharCode(mapDigit(ch.charCodeAt(0)));
  }
  return result;
}

/** فقط ارقام (لاتین) — برای موبایل، کد ملی و مبلغ ورودی. */
export function keepDigitsOnly(value: string | null | undefined): string {
  return latinDigits(value).replace(/[^0-9]/g, '');
}

/** گروه‌بندی سه‌رقمی با جداکننده فارسی (ارقام لاتین؛ برای فارسی faDigits روی خروجی). */
export function groupThousands(value: bigint | number | string): string {
  const text = String(value);
  const negative = text.startsWith('-');
  const digits = negative ? text.slice(1) : text;
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, PERSIAN_THOUSANDS_SEPARATOR);
  return negative ? `-${grouped}` : grouped;
}

/** عدد با جداکننده هزار و ارقام فارسی (نمایش شمارنده‌ها و مقادیر). */
export function formatNumber(value: number | bigint, options: { persianDigits?: boolean } = {}): string {
  const text = groupThousands(typeof value === 'number' ? Math.trunc(value) : value);
  return options.persianDigits === false ? text : faDigits(text);
}
